import React, { AllHTMLAttributes, Ref } from 'react';
import { mergeClassNames } from '../utilities';

type FormGroupProps = AllHTMLAttributes<HTMLDivElement>;

const getClasses = () => {
  return ['vl-form__group'].join(' ');
};

export const SwFormGroup = React.forwardRef(
  (
    { className, children, ...rest }: FormGroupProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    const classes = getClasses();

    return (
      <div {...rest} ref={ref} className={mergeClassNames(classes, className)}>
        {children}
      </div>
    );
  },
);
